<ng-content select="caption" />
@if (_isNativeHtmlTable) {
    <thead>
        <ng-container headerRowOutlet />
    </thead>
    <tbody>
        <ng-container rowOutlet />
        <ng-container noDataRowOutlet />
    </tbody>
    <tfoot>
        <ng-container footerRowOutlet />
    </tfoot>
} @else {
    <ng-container headerRowOutlet />
    <ng-container rowOutlet />
    <ng-container noDataRowOutlet />
    <ng-container footerRowOutlet />
}
